import { cn } from '~/lib/cn';

/**
 * White card-payment notification floated over a photo (tech Figma 1362:66130,
 * 1357:55363). Drawn on the 79px-tall design toast with every size in em, so
 * 1em is one design pixel: the caller scales it by setting `font-size`.
 */
export function TransactionToast({
  label,
  amount,
  logo,
  width = 313,
  logoSize = 36.7,
  tileClassName = 'bg-[#f0f0f0]',
  logoClassName,
  className,
}: {
  label: string;
  amount: string;
  logo: string;
  /** Toast width in design pixels. */
  width?: number;
  /** Logo size in design pixels on the 50.14px tile. */
  logoSize?: number;
  tileClassName?: string;
  logoClassName?: string;
  className?: string;
}) {
  return (
    <div
      style={{ width: `${width}em` }}
      className={cn(
        'flex h-[79em] items-center gap-[15.6em] rounded-[20.9em] bg-white px-[14.63em]',
        className,
      )}>
      <span
        className={cn(
          'grid size-[50.14em] shrink-0 place-items-center overflow-hidden rounded-[12.54em]',
          tileClassName,
        )}>
        <img
          src={logo}
          alt=""
          loading="lazy"
          style={{ width: `${logoSize}em`, height: `${logoSize}em` }}
          className={cn('max-w-none object-contain', logoClassName)}
        />
      </span>
      <span className="flex-1 text-[14.35em] leading-[1.2] font-semibold tracking-[-0.01em] text-black">
        {label}
      </span>
      <span className="text-[14.35em] leading-[1.16] font-semibold tracking-[-0.006em] whitespace-nowrap text-grey-1000">
        {amount}
      </span>
    </div>
  );
}
